
    <template>
      <section class="relax-doc">
        <h1>Message 消息</h1>
<blockquote>
<p>消息通知</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>最基本的提示，默认在 <code>1.5</code> 秒后消失。</p>
</blockquote>
<demo-block>
        <p><code>message</code> 会被挂载在 <code>vue</code> 全局属性中, 当然也可以引入 <code>RelaxPlus</code> 直接使用</p>

        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
   &lt;x-button type='primary' @click=&quot;handerClick&quot;&gt;显示普通提示&lt;/x-button&gt;
&lt;/template&gt;

&lt;script&gt;
  import {getCurrentInstance} from 'vue'
  export default {
    setup(){
      const instance = getCurrentInstance()
      const {$message} = instance.appContext.config.globalProperties
      const handerClick = () =&gt; {
        $message('你好呀')
      }
      return {
        handerClick
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="ti-shi-lei-xing"><a class="header-anchor" href="#ti-shi-lei-xing"></a> 提示类型</h2>
<blockquote>
<p>调用 <code>message</code> 下的 <code>info</code> <code>error</code> <code>success</code> <code>warning</code>来选择合适的场景。</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
   &lt;x-button type=&quot;info&quot; plain @click=&quot;open1&quot;&gt;显示信息提示&lt;/x-button&gt;
   &lt;x-button type=&quot;danger&quot; plain @click=&quot;open2&quot;&gt;显示错误提示&lt;/x-button&gt;
   &lt;x-button type=&quot;success&quot; plain @click=&quot;open3&quot;&gt;显示成功提示&lt;/x-button&gt;
   &lt;x-button type=&quot;warning&quot; plain @click=&quot;open4&quot;&gt;显示警告提示&lt;/x-button&gt;
&lt;/template&gt;

&lt;script&gt;
  import {getCurrentInstance} from 'vue'
  export default {
    setup(){
      const instance = getCurrentInstance()
      const {$message} = instance.appContext.config.globalProperties
      const open1 = () =&gt; {
        $message.info('显示信息提示')
      }
      const open2 = () =&gt; {
        $message.error('显示错误提示')
      }
      const open3 = () =&gt; {
        $message.success('显示成功提示')
      }
      const open4 = () =&gt; {
        $message.warning('显示警告提示')
      }
      return {
        open1,
        open2,
        open3,
        open4
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="jia-zai-zhong"><a class="header-anchor" href="#jia-zai-zhong"></a> 加载中</h2>
<blockquote>
<p><code>Loading</code> 的状态，并异步在某个时机移除。</p>
</blockquote>
<demo-block>
        <p>关闭时间为 <code>0</code> 的时候需要手动关闭</p>

        <template #source><element-demo2 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-button type=&quot;primary&quot; plain @click=&quot;loading&quot;&gt;显示加载中&lt;/x-button&gt;
  &lt;x-button type=&quot;primary&quot; plain @click=&quot;info&quot;&gt;3秒后自动关闭&lt;/x-button&gt;
&lt;/template&gt;
&lt;script&gt;
import {getCurrentInstance} from 'vue'
export default {
  setup(){
    const instance = getCurrentInstance()
    const {$message} = instance.appContext.config.globalProperties

    const loading = () =&gt; {
      const message = $message.loading('3秒后自动关闭', 0)
      setTimeout(message, 3000)
    }

    const info = () =&gt; {
      $message('message 消息', 3)
    }
    return {
      loading,
      info
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createBlock(_component_x_button, {
    type: "primary",
    onClick: _ctx.handerClick
  }, {
    default: _withCtx(() => [
      _createTextVNode("显示普通提示")
    ]),
    _: 1
  }, 8, ["onClick"]))
}
  
    
        const {getCurrentInstance} = Vue
        
  const democomponentExport = {
    setup(){
      const instance = getCurrentInstance()
      const {$message} = instance.appContext.config.globalProperties
      const handerClick = () => {
        $message('你好呀')
      }
      return {
        handerClick
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      type: "info",
      plain: "",
      onClick: _ctx.open1
    }, {
      default: _withCtx(() => [
        _createTextVNode("显示信息提示")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_button, {
      type: "danger",
      plain: "",
      onClick: _ctx.open2
    }, {
      default: _withCtx(() => [
        _createTextVNode("显示错误提示")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_button, {
      type: "success",
      plain: "",
      onClick: _ctx.open3
    }, {
      default: _withCtx(() => [
        _createTextVNode("显示成功提示")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_button, {
      type: "warning",
      plain: "",
      onClick: _ctx.open4
    }, {
      default: _withCtx(() => [
        _createTextVNode("显示警告提示")
      ]),
      _: 1
    }, 8, ["onClick"])
  ], 64))
}
  
    
        const {getCurrentInstance} = Vue
        
  const democomponentExport = {
    setup(){
      const instance = getCurrentInstance()
      const {$message} = instance.appContext.config.globalProperties
      const open1 = () => {
        $message.info('显示信息提示')
      }
      const open2 = () => {
        $message.error('显示错误提示')
      }
      const open3 = () => {
        $message.success('显示成功提示')
      }
      const open4 = () => {
        $message.warning('显示警告提示')
      }
      return {
        open1,
        open2,
        open3,
        open4
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_button = _resolveComponent("x-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_button, {
      type: "primary",
      plain: "",
      onClick: _ctx.loading
    }, {
      default: _withCtx(() => [
        _createTextVNode("显示加载中")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_x_button, {
      type: "primary",
      plain: "",
      onClick: _ctx.info
    }, {
      default: _withCtx(() => [
        _createTextVNode("3秒后自动关闭")
      ]),
      _: 1
    }, 8, ["onClick"])
  ], 64))
}
  
    
        const {getCurrentInstance} = Vue
        
const democomponentExport = {
  setup(){
    const instance = getCurrentInstance()
    const {$message} = instance.appContext.config.globalProperties

    const loading = () => {
      const message = $message.loading('3秒后自动关闭', 0)
      setTimeout(message, 3000)
    }

    const info = () => {
      $message('message 消息', 3)
    }
    return {
      loading,
      info
    }
  }
}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  